<template>
  <form @submit.prevent="handleFormSubmit" class="form">
    <register-input
      componentID="user-iin"
      :label="$t('iin')"
      :inputPlaceholder="$t('iin')"
      :isRequired="true"
      class="form__input"
      :inputMaxLength="12"
      v-model="iin"
    />
    <p class="login-form__error" v-if="iin.length == 12 && !validateIin()">
      {{ $t("incorrect iin") }}
    </p>
    <register-input
      componentID="user-last-name"
      :label="$t('last name')"
      inputType="text"
      :inputPlaceholder="$t('last name')"
      :isRequired="true"
      class="form__input"
      v-model="lastName"
    />
    <register-input
      componentID="user-first-name"
      :label="$t('first name')"
      inputType="text"
      :inputPlaceholder="$t('first name')"
      :isRequired="true"
      class="form__input"
      v-model="firstName"
    />
    <register-input
      componentID="user-patronymic"
      :label="$t('patronymic')"
      inputType="text"
      :inputPlaceholder="$t('patronymic')"
      class="form__input"
      v-model="patronymic"
    />
    {{ /* TODO: переделать поле ввода мобильного телефона использую компонент RegisterInput */  }}
    <div class="input-container">
      <label for="user-phone" class="label">
        {{ $t("mobile number") }}
        <span class="form__red">*</span>
      </label>
      <input
        type="tel"
        class="input"
        :placeholder="$t('mobile number')"
        required
        maxlength="16"
        id="user-phone"
        v-model="formatedPhoneValue"
        @keyup="formatPhone"
        @blur="formatPhone"
      />
    </div>
    <register-input
      componentID="user-email"
      :label="$t('email address')"
      inputType="email"
      :inputPlaceholder="$t('email address')"
      class="form__input"
      :isRequired="true"
      v-model="email"
    />
    <!-- <div class="form__rules-confirm"> -->
    <!--  <input -->
    <!--    v-model="rulesAccepted"-->
    <!--    type="checkbox" -->
    <!--    class="form__checkbox" -->
    <!--    id="confirm-checkbox" -->
    <!--   /> -->
    <!--   <span class="form__rules-label"> -->
    <!--     Даю согласие на обработку персональных данных, на использование -->
    <!--     обезличенных персональных данных в коммерческих целях -->
    <!--   </span> -->
    <!-- </div> -->
    <!-- <div class="form__errors"> -->
    <!--   <div -->
    <!--     v-for="(errorsArray, field) in registrationErrors" -->
    <!--     :key="field" -->
    <!--     class="form__error" -->
    <!--   > -->
    <!--     <span v-for="error in errorsArray" :key="error" class="form__error">{{ -->
    <!--       error -->
    <!--     }}</span> -->
    <!--   </div> -->
    <!-- </div> -->
    <button type="submit" class="form__submit-button button filled">
      {{ $t("confirm") }}
    </button>
  </form>
</template>

<script>
import RegisterInput from "@/components/register/Input";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "register-input": RegisterInput
  },
  data() {
    return {
      iin: "",
      firstName: "",
      lastName: "",
      patronymic: "",
      formatedPhoneValue: "+7",
      email: "",
      rulesAccepted: false
    };
  },
  computed: {
    ...mapGetters(["registrationErrors", "isRegistrationSuccess"])
  },
  methods: {
    // Функция для форматирования номера телефона в процессе ввода пользователем
    // TODO: при зажатии клавиши ввода длина получается больше допустимой
    formatPhone() {
      let num = this.formatedPhoneValue.replace(/\D/g, "").split(/(?=.)/);
      let i = num.length - 1;
      if (0 <= i) num.unshift("+");
      if (1 <= i) num.splice(2, 0, " ");
      if (4 <= i) num.splice(6, 0, " ");
      if (7 <= i) num.splice(10, 0, "-");
      if (9 <= i) num.splice(13, 0, "-");

      this.formatedPhoneValue = num.join("");
    },
    // Функция валидации ИИН
    validateIin() {
      let s = 0;
      let i = 0;
      let k = 0;
      let t = 0;

      for (i = 0; i < 11; i++) {
        s = s + (i + 1) * this.iin[i];
      }

      k = s % 11;

      if (k == 10) {
        s = 0;

        for (i = 0; i < 11; i++) {
          t = (i + 3) % 11;

          if (t == 0) {
            t = 11;
          }

          s = s + t * this.iin[i];
        }

        k = s % 11;

        if (k == 10) {
          return false;
        }
      }
      return k == this.iin.substring(11, 12);
    },
    registerAction() {
      this.$toasted.clear();
      this.$toasted.show(this.$t("loading"), { duration: 100000 });
      let data = {
        iin: this.iin,
        firstName: this.firstName,
        lastName: this.lastName,
        patronymic: this.patronymic,
        phoneNumber: this.formatedPhoneValue,
        email: this.email,
        is_legal: false
      };
      // console.log(data);
      this.register(data).then(res => {
        this.$toasted.clear();
        if (res.data.status) {
          this.$toasted.success(this.$t("data sent"));
          this.$router.push("/auth/register/basic-thank");
        } else {
          this.$toasted.clear();
          this.$toasted.error(this.$t("error"));
          if (res.data.result.errors) {
            Object.entries(res.data.result.errors).forEach(error => {
              console.log(error);
              this.$toasted.show(this.$t("incorrect form format"), {
                duration: 5000
              });
            });
          }
        }
      });

      //  this.register({
      //    iin: this.iin,
      //    firstName: this.firstName,
      //    lastName: this.lastName,
      //    patronymic: this.patronymic,
      //    phoneNumber: this.formatedPhoneValue,
      //    email: this.email,
      //    is_legal: false
      //  })
      //    .then(isSuccess => {
      //      this.$toasted.clear();
      //      if (isSuccess) {
      //        this.$toasted.success("Данные отправленны");
      //        this.$router.push("/auth/register/basic-thank");
      //      }
      //    })
      //    .catch(() => {
      //      this.$toasted.clear();
      //      this.$toasted.success("Произошла ошибка");
      //    });
    },
    // Обработчик отправки данных формы
    // TODO: Саяжан на уведомления надо будет прописать "i18n"
    handleFormSubmit() {
      if (this.validateIin()) {
        // <!-- if (this.rulesAccepted) { -->
        this.registerAction();
        // <!--} else { -->
        // <!--  this.$toasted.error( -->
        // <!--    "Для продолжения регистрации необходимо Ваше согласие на обработку персональных данных" -->
        // <!--  ); -->
        // <!--} -->
      } else {
        this.$toasted.error(this.$t("incorrect iin"));
      }
    },
    ...mapActions(["register"])
  }
};
</script>

<style scoped>
.form {
  color: #ffffff;
}

.form__title {
  margin-bottom: 20px;
  text-align: center;
}

.form__red {
  color: red;
}

.input-container {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.label {
  margin-bottom: 10px;
  font-size: 15px;
}

.input {
  padding: 10px 15px;
  border-radius: 5px;
  outline: none;
  border: none;
  box-sizing: border-box;
}

.form__rules-confirm {
  display: block;
}

.form__rules-label {
  padding: 5px;
}

.form__checkbox {
  outline: none;
  border: none;
}

.form__errors {
  width: 100%;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.form__error {
  color: red;
  margin-bottom: 5px;
}

.form__submit-button {
  width: 100%;
  margin-top: 20px;
  padding: 15px 0;
  font-size: 15px;
}
</style>
